(() => {
  const qs = (root, sel) => root.querySelector(sel);

  const getStep = (track) => {
    const slide = qs(track, ".cart-cross-sell__slide");
    if (!slide) return 0;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

    return slide.getBoundingClientRect().width + gap;
  };

  const setBtnState = (btn, enabled) => {
    if (!btn) return;
    btn.disabled = !enabled;
    btn.setAttribute("aria-disabled", String(!enabled));
    btn.classList.toggle("is-disabled", !enabled);
  };

  const refreshNavVisibility = (root) => {
    const countEl = qs(root, "[data-cs-count]");
    const nav = qs(root, ".cart-cross-sell__nav");
    if (!countEl || !nav) return;

    const count = parseInt((countEl.textContent || "").trim(), 10) || 0;
    nav.style.display = count > 1 ? "" : "none";
  };

  const refreshArrowStates = (root) => {
    const track = qs(root, "[data-cs-track]");
    if (!track) return;

    const prevBtn = qs(root, "[data-cs-prev]");
    const nextBtn = qs(root, "[data-cs-next]");

    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    const eps = 2;

    const canScrollPrev = track.scrollLeft > eps;
    const canScrollNext = track.scrollLeft < (maxScrollLeft - eps);

    setBtnState(prevBtn, canScrollPrev);
    setBtnState(nextBtn, canScrollNext);
  };

  const refreshRoot = (root) => {
    refreshNavVisibility(root);
    refreshArrowStates(root);
  };

  const refreshAll = () => {
    document.querySelectorAll(".cart-cross-sell").forEach(refreshRoot);
  };

  document.addEventListener("click", (e) => {
    const prev = e.target.closest("[data-cs-prev]");
    const next = e.target.closest("[data-cs-next]");
    if (!prev && !next) return;

    const root = e.target.closest(".cart-cross-sell");
    const track = root && qs(root, "[data-cs-track]");
    if (!root || !track) return;

    const btn = prev || next;
    if (btn.disabled) return;

    e.preventDefault();

    const step = getStep(track);
    if (!step) return;

    track.scrollBy({ left: prev ? -step : step, behavior: "smooth" });

    window.setTimeout(() => refreshArrowStates(root), 350);
  });

  document.addEventListener(
    "scroll",
    (e) => {
      const track = e.target;
      if (!(track instanceof Element)) return;
      if (!track.matches(".cart-cross-sell__track")) return;

      const root = track.closest(".cart-cross-sell");
      if (!root) return;

      refreshArrowStates(root);
    },
    true
  );

  window.addEventListener("resize", refreshAll);

  refreshAll();

  new MutationObserver(refreshAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();